import {SagaIterator} from "redux-saga";
import {call, put, takeEvery} from "redux-saga/effects";
import {fetchAuthenticationMethod, signInOperation} from "store/operation/operations";
import {SagaResult, WithPayload} from "types/basic";
import {login} from "./SignInPage.action";
import {AppRouteUrl, SignInPageFormData} from "@pinch-financial/pinch-ui-components";
import {AuthenticationMethod} from "types/enums/authenticationMethod";
import {keycloakSignIn} from "~/store/actions/auth.action";
import {Operation} from "~/store/operation/Operation";
import {setPageStatus} from "~/store/actions/applicantMeta.action";

export function* loginWithEmailPassword({
  payload: {email, password, navigate},
}: WithPayload<SignInPageFormData>): SagaIterator {
  if (window._env_.REACT_APP_AUTHENTICATION_METHOD.toUpperCase() === "KEYCLOAK") {
    const authenticationMethod: AuthenticationMethod = yield call(
      fetchAuthenticationMethod.saga,
      email
    );
    if (authenticationMethod === AuthenticationMethod.OKTA) {
      navigate(AppRouteUrl.MIGRATE_CONFIRMATION, {
        state: {
          username: email,
        },
      });
    } else {
      yield put(setPageStatus({page: "SIGN_IN", status: "submitting"}));

      const result: SagaResult<void> = yield call(signInOperation.saga, email, password);
      // If sign in succeeds, signIn page status will be unset by Route component when pathname changes, or Root component when unmount.
      // Because there will be multiple times of sign in page rerendering and not controlled by this page.

      if (Operation.isSuccess(result)) {
        yield put(keycloakSignIn({navigate}));
      } else {
        yield put(setPageStatus({page: "SIGN_IN", status: "error"}));
      }
    }
  } else {
    const result = yield call(signInOperation.saga, email, password);
  }
}

export default function* loginFormSaga(): SagaIterator {
  yield takeEvery(login, loginWithEmailPassword);
}
